import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { getmockTest, ModalToggle, isOpenModal, addmockTest, updatemockTest, isOpenStatusModal, statusToggle, statusUpdatemockTest, statusDeletemockTest, } from '../../store/mockTestSlice';
import { getTestSeries } from '../../store/testSeriesSlice';
import { useLocation, useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { frontEndURL } from '../../shared/_services/api_service';
import { errorHandler, successHandler } from '../../shared/_helper/responseHelper';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment/moment';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


const MockTestTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const storeVar = useSelector(state => state.mockTest)
  const testSeriesVar = useSelector(state => state.testSeries)
  const { layoutURL } = useContext(CustomizerContext);
  const [mainId, setmainId] = useState()
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const statusModalToggle = () => dispatch(statusToggle());
  const [stateStatus, setStateStatus] = useState('active');
  const [submit, setSubmit] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 800;
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,
    title: '',
    duration: '',
    correctMarks: '',
    inCorrectMarks: '',
    testSeriesId: '',
    mockTestId: '',
    duration: '',
    forNoOfQuestions: '',
    isSwitchable: 'true',
    price: '',
    publishDate: '',
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setmainId(id);
    dispatch(getmockTest(formVar.limit, formVar.offset, formVar.status, formVar.keyword, id))
    dispatch(getTestSeries(100, 0, '', '', ''))

  }, [location.search, dispatch]);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getmockTest(formVar.limit, offset, formVar.status, formVar.keyword, mainId))
  };
  const searchState = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: e.target.value }))
    searchWithDelay(e.target.value)
  }
  const searchWithDelay = (keyword) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(getmockTest(formVar.limit, formVar.offset, formVar.status, keyword, mainId))
    }, typingDelay);
    setTypingTimer(timer);
  };
  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, status: e.target.value }))
    dispatch(getmockTest(formVar.limit, formVar.offset, e.target.value, formVar.keyword, mainId))
  };
  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      mockTestId: data._id,
      modalTitle: 'Edit Mock Test',
      title: data.title,
      duration: data.duration,
      price: data.price,
      correctMarks: data.correctMarks,
      inCorrectMarks: data.inCorrectMarks,
      forNoOfQuestions: data.forNoOfQuestions,
      testSeriesId: data.testSeriesId._id,
      publishDate: data.publishDate,
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setSubmit(false)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Mock Test',
      title: '',
      duration: '',
      correctMarks: '',
      inCorrectMarks: '',
      testSeriesId: mainId,
      mockTestId: '',
      forNoOfQuestions: '',
    }))
  }
  const onValueChange = (event) => {
    setStateStatus(event.target.value)
  }
  const statusToggleModal = (data) => {
    dispatch(isOpenStatusModal(true))
    setStateStatus(data.status)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      mockTestId: data._id,
    }))
  }

  const submitMenu = () => {
    if (titleValid() || positiveMarksValid() || negativeMarksValid() || testSeriesValid() || durationValid() || forNoOfQuestionsValid() || priceValid() || publishValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)

    if (formVar.editState) {
      dispatch(updatemockTest(formVar.mockTestId, { title: formVar.title, testSeriesId: formVar.testSeriesId, duration: formVar.duration, correctMarks: formVar.correctMarks, inCorrectMarks: formVar.inCorrectMarks, isSwitchable: formVar.isSwitchable, forNoOfQuestions: formVar.forNoOfQuestions, price: formVar.price, publishDate: formVar.publishDate,   }))
    } else {
      dispatch(addmockTest({ title: formVar.title, testSeriesId: formVar.testSeriesId, duration: formVar.duration, correctMarks: formVar.correctMarks, inCorrectMarks: formVar.inCorrectMarks, isSwitchable: formVar.isSwitchable, forNoOfQuestions: formVar.forNoOfQuestions, price: formVar.price, publishDate: formVar.publishDate,   }))
    }
  }
  const submitStatus = () => {
    dispatch(statusUpdatemockTest({ id: formVar.mockTestId, status: stateStatus }))
  }


  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }
  const positiveMarksValid = () => {
    if (!formVar.correctMarks) {
      return "Marks for Each Question  is required";
    }
  }
  const negativeMarksValid = () => {
    if (!formVar.inCorrectMarks.toString()) {
      return "Negative Marks is Required";
    }
  }
  const forNoOfQuestionsValid = () => {
    if (!formVar.forNoOfQuestions) {
      return "For Number Of  Question is required";
    }
  }
  const durationValid = () => {
    if (!formVar.duration) {
      return "Duration is Required";
    }
  }
  const priceValid = () => {
    if (formVar.price === null || formVar.price === undefined || formVar.price === '')
      return "Price is Required";
  }

  const publishValid = () => {
    if (!formVar.publishDate) {
      return "Publish Date is Required";
    }
  }
  const testSeriesValid = () => {
    if (!formVar.testSeriesId) {
      return "Test Series is required";
    }
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(statusDeletemockTest({ id: data._id, status: 'deleted' }))
        }
      });
  }


  const handleShare = (e, id) => {
    e.stopPropagation();
    const shareURL = `${frontEndURL}${id}`;
    navigator.clipboard.writeText(shareURL)
      .then(() => {
        successHandler("Link copied to clipboard!");
      })
      .catch(() => {
        errorHandler("Failed to copy link.");
      });
  };

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
                <Input className="form-control" placeholder='Serch..' type="text" id="yourInputId"
                  value={formVar.keyword} onChange={(e) => searchState(e)}
                />
              </Col>
              <Col md="4">
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.status} onChange={handleInputChange}>
                  <option value='active'>ACTIVE</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add MockTest
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Title</th>
                  <th scope='col'>Test</th>
                  <th scope='col'>Correct Marks</th>
                  <th scope='col'>InCorrect Marks</th>
                  <th scope='col'>Price</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.mockTestData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.testSeriesId.title}</td>
                    <td>{item.correctMarks}</td>
                    <td>{item.inCorrectMarks}</td>
                    <td>{item.price}</td>
                    <td>
                      {
                        item.status === 'active' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Active</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'pending' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Pending</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'DEACTIVE' && <>
                          <span className={`font-danger w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                            {item.status === 'DEACTIVE' && (
                              <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                            )}
                            &nbsp; <span>{item.status}</span>
                          </span>
                        </>
                      }
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-warning action-icon'>
                          <i className="fa fa-list-ol fa-lg" onClick={(e) => navigate('/lessons/' + layoutURL + '?id=' + item._id + '&type=mockTest')}></i>
                          <div className="tooltipCustom">Lessons</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-success action-icon'>
                          <i className="fa fa-share-alt fa-lg" onClick={(e) => handleShare(e, item._id)}></i>
                          <div className="tooltipCustom">Share Exam</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-info action-icon'>
                          <i className="fa fa-toggle-on fa-lg" onClick={(e) => statusToggleModal(item)}></i>
                          <div className="tooltipCustom">Status Update</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalmockTest <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalmockTest > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalmockTest}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} size={'lg'}>
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Mock Test Name</Label>
            <Input className="form-control" type="text" placeholder='Enter Mock Test Name' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
            <Col md='12'>
              <Label className="col-form-label" for="recipient-name">Exam</Label>
              <select className="form-control form-control-inverse " name="select" type="select"
                value={formVar.testSeriesId} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, testSeriesId: e.target.value }))} disabled>
                <option value="" >Select Exam</option>
                {testSeriesVar?.testSeriesData?.map((item, index) => (
                  <option key={index} value={item._id}>{item.title}</option>
                ))}
              </select>
              {submit && testSeriesValid() ? <span className='d-block font-danger'>{testSeriesValid()}</span> : ""}
            </Col>
            <Label className="col-form-label" for="recipient-name">Marks for Each Question</Label>
            <Input className="form-control" type="text" placeholder='Enter Marks' onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, correctMarks: e.target.value }))} value={formVar.correctMarks} />
            {submit && positiveMarksValid() ? <span className='d-block font-danger'>{positiveMarksValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Negative Marks </Label>
            <Input className="form-control" type="text" placeholder='Enter Negative Marks' onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, inCorrectMarks: e.target.value }))} value={formVar.inCorrectMarks} />
            {submit && negativeMarksValid() ? <span className='d-block font-danger'>{negativeMarksValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">For Number of Question </Label>
            <Input className="form-control" type="text" placeholder='Enter For Number of Question' onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, forNoOfQuestions: e.target.value }))} value={formVar.forNoOfQuestions} />
            {submit && forNoOfQuestionsValid() ? <span className='d-block font-danger'>{forNoOfQuestionsValid()}</span> : ""}
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Test Duration</Label>
                <Input className="form-control" type="text" placeholder='Enter Test Duration' onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, duration: e.target.value }))} value={formVar.duration} />
                {submit && durationValid() ? <span className='d-block font-danger'>{durationValid()}</span> : ""}
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Price</Label>
                <Input className="form-control" type="text" placeholder='Enter Price' onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(" ", "").slice(0, 4)} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, price: e.target.value }))} value={formVar.price} />
                {submit && priceValid() ? <span className='d-block font-danger'>{priceValid()}</span> : ""}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label className="col-form-label">Select Date & Time</Label>
                <DatePicker
                  selected={formVar.publishDate ? new Date(formVar.publishDate) : null}
                  onChange={(publishDate) => setFormVar((prevFormVar) => ({ ...prevFormVar, publishDate }))}
                  showTimeSelect
                  dateFormat="Pp"
                  className="form-control"
                  minDate={new Date()}
                  filterTime={(time) => {
                    const selectedDate = moment(formVar.publishDate);
                    const now = moment();
                    return selectedDate.isAfter(now.clone().startOf("day")) || moment(time).isSameOrAfter(now);
                  }}
                />
                {submit && publishValid() ? <span className='d-block font-danger'>{publishValid()}</span> : ""}
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Lesson Switchable</Label>
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, isSwitchable: e.target.value }))} value={formVar.isSwitchable}>
                  <option value='yes'>YES</option>
                  <option value='no'>NO</option>
                </Input>
              </Col>
            </Row>
           
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isStatusOpenModal} title={'Status'} toggler={statusModalToggle} >
        <Col>
          <div className='d-flex m-15 m-checkbox-inline justify-content-center custom-radio-ml'>
            <div className='radio radio-primary'>
              <Input id='radioinline1' type='radio' className="radio_animated" name='radio1' checked={stateStatus === 'active'} onChange={onValueChange} value='active' />
              <Label className='mb-0' for='radioinline1'>
                <span className='digits'>ACTIVE</span>
              </Label>
            </div>
            <div className='radio radio-primary'>
              <Input id='radioinline3' type='radio' className="radio_animated" name='radio3' checked={stateStatus === 'pending'} onChange={onValueChange} value='pending' />
              <Label className='mb-0' for='radioinline3'>
                <span className='digits'>PENDING</span>
              </Label>
            </div>
          </div>
        </Col>
        <ModalFooter className='justify-content-center'>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default MockTestTable;
